import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

interface UseUpdatePublicCompanyLeadContractProductRequireProductCreditQuota {
  publicCompanyLeadId?: string
  onSuccess?: (response: AxiosResponse) => void
  onError?: (error: ErrorResponse) => void
}

export const useUpdatePublicCompanyLeadContractProductRequireProductCreditQuota = ({
  publicCompanyLeadId,
  onSuccess,
  onError,
}: UseUpdatePublicCompanyLeadContractProductRequireProductCreditQuota) => {
  const publicAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updatePublicCompanyLeadContractProductRequireProductCreditQuota'],
    mutationFn: async (requireProductCreditQuota: boolean) => {
      const contract = {
        require_product_credit_quota: requireProductCreditQuota,
      }

      return await publicAxios.put(`/funnel/public/leads/${publicCompanyLeadId}/update_contract_products`, {
        contract,
      })
    },
    onSuccess,
    onError,
  })
}
